import { useState, useEffect } from "react";
import { useStore } from "../../context/StoreContext";

export interface InvestigatorOption {
  value: string;
  label: string;
  averageRating?: number;
  isNone?: boolean;
}

export function useFieldResourceData() {
  const { fieldResources } = useStore();
  const [fieldResourceList, setFieldResourceList] = useState<
    InvestigatorOption[]
  >([]);

  useEffect(() => {
    if (fieldResources) {
      const emptyInvestigator = {
        id: "",
        name: "None",
        average_rating: 0,
      };

      const investigators: InvestigatorOption[] = [
        ...fieldResources,
        emptyInvestigator,
      ].map((inv: any) => ({
        value: inv.id,
        label: inv.name,
        averageRating: inv.average_rating, // Add extra data for formatting
        isNone: inv.name === "None",
      }));

      setFieldResourceList(investigators);
    }
  }, [fieldResources]);

  return { fieldResourceList };
}
